export const UK = {
    "Open document": "ÐÑÐ´ÐºÑÐ¸ÑÐ¸ Ð´Ð¾ÐºÑÐ¼ÐµÐ½Ñ",
    "Upload file": "ÐÐ°Ð²Ð°Ð½ÑÐ°Ð¶Ð¸ÑÐ¸ ÑÐ°Ð¹Ð»",
    "Drop file here to upload": "ÐÐµÑÐµÑÑÐ³Ð½ÑÑÑ ÑÐ°Ð¹Ð» Ñ ÑÑ Ð¾Ð±Ð»Ð°ÑÑÑ Ð´Ð»Ñ Ð·Ð°Ð²Ð°Ð½ÑÐ°Ð¶ÐµÐ½Ð½Ñ",
    "Disc": "ÐÑÐ¸ÑÑÑÑÐ¹",
    "URL": "ÐÐ¾ÑÐ¸Ð»Ð°Ð½Ð½Ñ",
    "FILE": "Ð¤Ð°Ð¹Ð»",
    "SIZE": "Ð Ð¾Ð·Ð¼ÑÑ",
    "MB": "ÐÐ",
    "KB": "ÐÐ",
    "Bytes": "ÐÐ°Ð¹Ñ",
    "Loading... Please wait.": "ÐÐ°Ð²Ð°Ð½ÑÐ°Ð¶ÐµÐ½Ð½Ñ... ÐÐ°ÑÐµÐºÐ°Ð¹ÑÐµ, Ð±ÑÐ´Ñ Ð»Ð°ÑÐºÐ°.",
    "Fit Width": "ÐÐ¾ ÑÐ¸ÑÐ¸Ð½Ñ",
    "Fit Height": "ÐÐ¾ Ð²Ð¸ÑÐ¾ÑÑ",
    "Password protected document": "ÐÐ¾ÐºÑÐ¼ÐµÐ½Ñ Ð·Ð°ÑÐ¸ÑÐµÐ½Ð¾ Ð¿Ð°ÑÐ¾Ð»ÐµÐ¼",
    "Password": "ÐÐ°ÑÐ¾Ð»Ñ",
    "Open": "ÐÑÐ´ÐºÑÐ¸ÑÐ¸",
    "Password Required": "ÐÐµÐ¾Ð±ÑÑÐ´Ð½Ð¾ Ð²Ð²ÐµÑÑÐ¸ Ð¿Ð°ÑÐ¾Ð»Ñ",
    "Incorrect password": "ÐÐµÐ¿ÑÐ°Ð²Ð¸Ð»ÑÐ½Ð¸Ð¹ Ð¿Ð°ÑÐ¾Ð»Ñ",
    "Error": "ÐÐ¾Ð¼Ð¸Ð»ÐºÐ°",
    "Something went wrong": "Ð©Ð¾ÑÑ Ð¿ÑÑÐ»Ð¾ Ð½Ðµ ÑÐ°Ðº",
    "Server is not available": "Ð¡ÐµÑÐ²ÐµÑ Ð½ÐµÐ´Ð¾ÑÑÑÐ¿Ð½Ð¸Ð¹",
    "of": "Ð·",
    "Please wait...": "ÐÐ°ÑÐµÐºÐ°Ð¹ÑÐµ, Ð±ÑÐ´Ñ Ð»Ð°ÑÐºÐ°..."
};